import React from 'react';
import './About.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import image21 from '../img/img-21.jpg';
import image23 from '../img/img-23.jpg';
import image24 from '../img/img-24.jpg';
import image25 from '../img/img-25.jpg';
import image26 from '../img/img-26.jpg';
import image27 from '../img/img-27.jpg';
import image28 from '../img/img-28.jpg';
import image29 from '../img/img-29.jpg';
import image30 from '../img/img-30.jpg';

// Moved sections imports
import image3 from '../img/img-3.jpg';
import image70 from '../img/img-70.jpg';
import image5 from '../img/img-5.jpg';
import image6 from '../img/img-6.jpg';
import image7 from '../img/img-7.jpg';
import trinityHospice from '../img/Trinity Hospice.jpg';
import ageUk from '../img/Age UK.jpg';
import britishHeartFoundation from '../img/British Heart Foundation.jpg';
import cancerResearch from '../img/Cancer Research-Uk.png';
import catsProtection from '../img/Cats Protection.png';
import BannerCarousel from '../BannerCarousel/BannerCarousel';
import image71 from '../img/img-71.jpg';
import image72 from '../img/img-72.jpg';
import image73 from '../img/img-73.jpg';
import image74 from '../img/img-74.jpg';
import image75 from '../img/img-75.jpg';

const About: React.FC = () => {
    return (
        <div className='about-page'>
            <Header onSearchClick={() => console.log("Search button clicked")} />

            {/* Hero Section */}
            <section className="hero-section10">
                <div className="hero-content10">
                    <h1 className="hero-title10">Connecting Souls for a Lifetime</h1>
                    <p className="hero-description10">
                        Discover your perfect life partner within the vibrant Global community through DateNow's comprehensive platform.
                    </p>
                </div>
            </section>

            {/* ---- Moved Sections Start ---- */}
            <section className='banner-section'>
                <BannerCarousel />
            </section>

            <div className="parent-container24">
                <div className="container24">
                    <div className="img3">
                        <img
                            loading="lazy"
                            decoding="async"
                            src={image3}
                            alt="Our Story Image"
                            width="645"
                            height="500"
                            title="Our Story"
                            className="image-hover-focus"
                        />
                    </div>
                    <div className="about2">
                        <h2>Our Story</h2>
                        <p>DateNow is committed to helping individuals find their soulmates with meaningful connections. With a focus on compatibility and a deep understanding of cultural values, we strive to make the journey of finding love easier and more fulfilling.</p>
                        <div className="hr2"></div>
                    </div>
                </div>
            </div>

           

            {/* Welcome Section */}
            <section className="welcome-section-about">
                <div className="section-header-about">
                    <h2 className="section-title-about">Welcome to DateNow</h2>
                </div>
                <div className="welcome-grid-about">
                    <div className="welcome-image-about">
                        <img src={image21} alt="DateNow Community" loading="lazy" />
                    </div>
                    <div className="welcome-content-about">
                        <p className="welcome-text-about">
                            With years of experience in the industry, DateNow is a trusted platform that connects individuals seeking marriage partners within the Global community.
                        </p>
                        <p className="welcome-text-about">
                            Our platform has successfully helped countless users find compatible matches, leading to lifetime partnerships and happy marriages.
                        </p>
                        <p className="welcome-text-about">
                            We provide a range of tools and features, including detailed profiles and personalized matchmaking services, to enhance the user experience and increase the chances of finding the right life partner.
                        </p>
                    </div>
                </div>
            </section>

            {/* Mission & Vision Section */}
            <section className="mission-vision-section-about">
                <div className="mission-vision-grid-about">
                    <div className="mission-card-about">
                        <div className="card-content-about">
                            <h3 className="card-title-about">Our Mission</h3>
                            <p className="card-subtitle-about">Empowering individuals to find love and companionship</p>
                            <p className="card-description-about">
                                At DateNow, our mission is to provide a reliable and user-friendly platform that empowers individuals to find their perfect life partner within the Global community. We are committed to leveraging technology and innovation to simplify and enhance the process of matchmaking, ensuring positive and lasting connections.
                            </p>
                        </div>
                        <div className="card-image-about">
                            <img src={image23} alt="Our Mission" loading="lazy" />
                        </div>
                    </div>
                    <div className="vision-card-about">
                        <div className="card-image-about">
                            <img src={image24} alt="Our Vision" loading="lazy" />
                        </div>
                        <div className="card-content-about">
                            <h3 className="card-title-about">Our Vision</h3>
                            <p className="card-subtitle-about">Creating a world where love knows no boundaries</p>
                            <p className="card-description-about">
                                Our vision is to create a world where love transcends boundaries and individuals have the freedom to choose their life partner based on genuine compatibility and shared values. We aim to be the premier matchmaking platform for the Global community, providing a safe, inclusive, and efficient space for individuals to embark on their lifelong journey of love and partnership.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="process-section-about">
                <div className="process-header-about">
                    <h2 className="process-title-about">Unveiling Our Process</h2>
                    <p className="process-description-about">
                        Working with DateNow behind the scenes is a seamless and personalized experience. Our dedicated team of professionals ensures meticulous attention to detail, delivering exceptional customer service and support throughout the matchmaking journey. From profile creation to finalizing matches, we are there every step of the way.
                    </p>
                </div>
            </section>


             <div className="container-fluid parent-container25 p-0">
                <div className="container25 text-center">
                    <h2>Our Services</h2>
                </div>
                <div className="img-stack d-flex justify-content-center">
                    <div className="img-stack-item">
                        <img src={image70} alt="Profiles" className="img-fluid" />
                        <h3>Profiles</h3>
                    </div>
                    <div className="img-stack-item">
                        <img src={image5} alt="Matchmaking" className="img-fluid" />
                        <h3>Matchmaking</h3>
                    </div>
                    <div className="img-stack-item">
                        <img src={image6} alt="Wedding Shopping" className="img-fluid" />
                        <h3>Wedding Shopping</h3>
                    </div>
                    <div className="img-stack-item">
                        <img src={image7} alt="Events" className="img-fluid" />
                        <h3>Events</h3>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="parent-container26 mx-4">
                    <div className="container26">
                        <div>
                            <h2>Find Your Perfect Match</h2>
                        </div>
                        <div>
                            <p>Start your journey to a happy and fulfilled married life by joining DateNow and finding your perfect match based on compatibility and shared values.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="parent-container27">
                <div className="work">
                    <h2>Our Weekly Donations go to</h2>
                </div>
                <div className="charity-badges-container">
                    <div className="charity-badge" onClick={() => window.open('https://www.trinityhospice.co.uk/', '_blank')}>
                        <img src={trinityHospice} alt="Trinity Hospice" />
                        <div className="badge-overlay">
                            <span>Trinity Hospice</span>
                        </div>
                    </div>
                    <div className="charity-badge" onClick={() => window.open('https://www.ageuk.org.uk/', '_blank')}>
                        <img src={ageUk} alt="Age UK" />
                        <div className="badge-overlay">
                            <span>Age UK</span>
                        </div>
                    </div>
                    <div className="charity-badge" onClick={() => window.open('https://www.bhf.org.uk/', '_blank')}>
                        <img src={britishHeartFoundation} alt="British Heart Foundation" />
                        <div className="badge-overlay">
                            <span>British Heart Foundation</span>
                        </div>
                    </div>
                    <div className="charity-badge" onClick={() => window.open('https://www.cancerresearchuk.org/', '_blank')}>
                        <img src={cancerResearch} alt="Cancer Research UK" />
                        <div className="badge-overlay">
                            <span>Cancer Research UK</span>
                        </div>
                    </div>
                    <div className="charity-badge" onClick={() => window.open('https://www.cats.org.uk/', '_blank')}>
                        <img src={catsProtection} alt="Cats Protection" />
                        <div className="badge-overlay">
                            <span>Cats Protection</span>
                        </div>
                    </div>
                </div>
            </div>
            {/* ---- Moved Sections End ---- */}

            {/* Instagram Section */}
            <section className="instagram-section-about">
                <div className="instagram-header-about">
                    <h2 className="instagram-title-about">Follow Our Journey</h2>
                    <a href="https://www.instagram.com/usedatenow?igsh=c3NsdmJxdzZ0bGUx&utm_source=qr" className="instagram-button-about" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram"></i>
                        Follow on Instagram
                    </a>
                </div>
                <div className="instagram-gallery-about">
                    <div className="instagram-image-about">
                        <img src={image71} alt="Instagram Post 1" loading="lazy" />
                    </div>
                    <div className="instagram-image-about">
                        <img src={image72} alt="Instagram Post 2" loading="lazy" />
                    </div>
                    <div className="instagram-image-about">
                        <img src={image73} alt="Instagram Post 3" loading="lazy" />
                    </div>
                    <div className="instagram-image-about">
                        <img src={image74} alt="Instagram Post 4" loading="lazy" />
                    </div>
                    <div className="instagram-image-about">
                        <img src={image75} alt="Instagram Post 5" loading="lazy" />
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default About;
